import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {VoucherDomainsComponent} from './voucher-domains.component';

const routes: Routes = [
  {path: 'voucher/domains', component: VoucherDomainsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class VoucherDomainsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/voucher/voucher-domains/voucher-domains-routing.module.ts